var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.35824 13.8361C3.73987 13.8361 0.800781 10.9147 0.800781 7.31807C0.800781 3.72143 3.73987 0.800003 7.35824 0.800003C10.9766 0.800003 13.9157 3.72143 13.9157 7.31807C13.9157 10.9147 10.9766 13.8361 7.35824 13.8361ZM7.35824 1.80278C4.29809 1.80278 1.80962 4.27631 1.80962 7.31807C1.80962 10.3598 4.29809 12.8334 7.35824 12.8334C10.4184 12.8334 12.9069 10.3598 12.9069 7.31807C12.9069 4.27631 10.4184 1.80278 7.35824 1.80278Z",
    fill: "#5A5C61"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5192 15.2001C13.4654 15.2001 13.4116 15.1934 13.3646 15.1867C13.0485 15.1466 12.4768 14.9327 12.154 13.9767C11.9858 13.4753 12.0463 12.9739 12.3221 12.5928C12.5978 12.2118 13.0619 11.9979 13.5932 11.9979C14.2792 11.9979 14.8173 12.2586 15.0594 12.7199C15.3015 13.1811 15.2343 13.7694 14.8509 14.3377C14.3734 15.053 13.8555 15.2001 13.5192 15.2001ZM13.1157 13.6625C13.23 14.0101 13.3915 14.1839 13.4991 14.1973C13.6067 14.2107 13.8084 14.0836 14.0169 13.7828C14.212 13.4953 14.2254 13.2881 14.1784 13.1945C14.1313 13.1009 13.943 13.0006 13.5932 13.0006C13.3847 13.0006 13.23 13.0675 13.1426 13.1811C13.0619 13.2948 13.0485 13.4686 13.1157 13.6625Z",
    fill: "#5A5C61"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.18691c03e61a68204980ed6a151f249a.svg";
export { ForwardRef as ReactComponent };